import { connect } from 'react-redux';
import CheckoutDialog from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutDialog);
